// extracted by mini-css-extract-plugin
export default {"areaContainer":"style_areaContainer__UAJsV","mixedStatuses":"style_mixedStatuses__b0EcU","openCloseAdvice":"style_openCloseAdvice__kXohA"};